function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 11");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 22,
  y: 19.41133,
  width: 567,
  height: 294.17734
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 567,
  height: 294.17734,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Webview_1",
  transform: "translate(-782.000000, -424.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F4F4F4",
  x: 0,
  y: 0,
  width: 1440,
  height: 1024
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(519.000000, 356.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E5E5E5",
  x: 0,
  y: 0,
  width: 609,
  height: 333
}), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-Copy",
  stroke: "#979797",
  mask: "url(#mask-2)",
  strokeWidth: 4,
  opacity: 0.303617932,
  strokeLinecap: "round",
  strokeDasharray: "10,22",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(264.000000, 69.000000)",
  stroke: "#CDCDCD",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.2701926,0 L57.0012295,15.7210767 C56.9267194,20.0566661 60.2481718,23.6348182 64.4201291,23.7116323 L80,24",
  id: "Stroke-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,29.4238537 L19.3903332,7.59500078 C19.465781,3.32570172 23.01058,-0.0756016025 27.3067392,0.0012780205 L56.5935756,0.520215476 C56.8217895,0.522075467 57.0487564,0.576015202 57.2545231,0.674594719 C57.2931823,0.691954634 57.3330886,0.712414533 57.3698772,0.734114427 C57.4945843,0.801694096 57.6068207,0.890353661 57.7072099,0.990793168 L81,24.1681395 L79.9917432,80.4043438 C79.9237778,84.1733053 77.1540334,87.2658501 73.550622,87.8846071 C73.0729939,87.9676867 72.5822715,88.0079865 72.0778313,87.9986865 L68.7705993,87.9410268",
  id: "Stroke-3",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.1426528,35.0880966 L70.9499753,55.0622871 C71.3371922,57.816213 69.4344034,60.3639826 66.6998383,60.753941 L64.7699197,61.0290231 L70.5868053,102.418015 C71.2077088,106.834232 68.1568343,110.918859 63.7716647,111.544159 L19.0468803,117.919482 C14.664177,118.54354 10.6057986,115.472307 9.98489513,111.05609 L0.0800349716,40.5822874 C-0.540251963,36.1679336 2.5124723,32.0802009 6.89517561,31.4555223 L51.61996,25.0808203 C55.7165667,24.4965037 59.5258438,27.1399 60.5154665,31.0897811 L62.4910126,30.8078685 C65.2255778,30.4179101 67.7560525,32.3347916 68.1426528,35.0880966 Z",
  id: "Stroke-5",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,117 L64.3785443,111.292794 L69.0544254,110.631574 C73.4719157,110.007572 76.5446553,105.926122 75.9191755,101.515304 L74.0042257,88",
  id: "Stroke-7",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-9",
  strokeLinejoin: "round",
  points: "52 25 19.8310362 29.8249103 12 31"
})))));

var SvgFolders = function SvgFolders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "120px",
    viewBox: "0 0 83 120",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folders.4dc63bd4.svg";
export { ForwardRef as ReactComponent };